const MOBILE_LANDSCAPE_ORIENTATION = 'landscape';

export { MOBILE_LANDSCAPE_ORIENTATION };
